import { render } from "./TownShops.vue?vue&type=template&id=6a0c4b32&scoped=true"
import script from "./TownShops.vue?vue&type=script&lang=js"
export * from "./TownShops.vue?vue&type=script&lang=js"

import "./TownShops.vue?vue&type=style&index=0&id=6a0c4b32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a0c4b32"]])

export default __exports__